export default __webpack_public_path__ + "static/media/wine-bottles.da04e955.png";